const transformTileType = _ref => {
  let {
    tileType = '',
    isPrivateSeller = false
  } = _ref;
  const tileName = tileType.split('_')[0];
  switch (tileName) {
    case 'CARFAX':
      {
        return 'carfaxVHR';
      }
    case 'EXPERIAN':
      {
        if (isPrivateSeller) {
          return 'autocheckps';
        }
        if (tileType === 'EXPERIAN_RETAIL') {
          return 'autocheckno';
        }
        return 'autocheck';
      }
    default:
      {
        return '';
      }
  }
};
export default transformTileType;